export enum RecordingType {
  CHECK_IN = 'checkin',
  CHECK_OUT = 'checkout',
}
